// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  width: 100%;
  height: 500px;
}

.carousel-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.carousel-item.active {
  opacity: 1;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: inherit;
  border: 2px solid #555;
}

.carousel-caption {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: black;
  padding-bottom: 1rem;
}
.carousel-caption .heading-five {
  padding-bottom: 0.5rem !important;
}

.carousel-control-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.carousel-control-next {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 20px;
  height: 20px;
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.carousel-indicators ul {
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
}

.carousel-indicators li {
  width: 12px;
  height: 12px;
  background-color: #ccc;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.carousel-indicators li.active {
  background-color: #333;
}

.carousel-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e0e0e0;
  border: 2px solid #555;
}

.carousel-placeholder span {
  font-size: 2rem;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/components/RecordingTable/MyCarousel.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AACF;AAAE;EACE,iCAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6CAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF","sourcesContent":[".carousel {\n  position: relative;\n  width: 100%;\n  height: 500px;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-item {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.carousel-item.active {\n  opacity: 1;\n}\n\n.carousel-image {\n  width: 100%;\n  height: 100%;\n  object-fit: inherit;\n  border: 2px solid #555;\n}\n\n.carousel-caption {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  color: black;\n  padding-bottom: 1rem;\n  .heading-five{\n    padding-bottom: 0.5rem !important;\n  }\n}\n\n.carousel-control-prev {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.carousel-control-next {\n  position: absolute;\n  top: 50%;\n  right: 0%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.carousel-indicators ul {\n  list-style: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n\n.carousel-indicators li {\n  width: 12px;\n  height: 12px;\n  background-color: #ccc;\n  border-radius: 50%;\n  margin: 0 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n}\n\n.carousel-indicators li.active {\n  background-color: #333;\n}\n\n.carousel-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e0e0e0; // Or any other placeholder background\n  border: 2px solid #555;\n}\n\n.carousel-placeholder span {\n  font-size: 2rem;\n  color: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
